import { RedirectionTypesEnum } from 'common/enums/ButtonActionEnum'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { useWebsiteSettings } from 'publisher/store'
import React from 'react'
import { useCalculateTypography } from 'src/publisher/shared/hooks/use-calculate-typography'
import { getWebsiteStylesTypographyHeading } from 'src/publisher/store/website-settings/website-settings-selector'
import { CommonForm } from 'src/shared/entities/form'
import {
  FormInterface,
  FormSubEntityTypeEnum,
} from 'src/shared/types/entities/form-interface'
import { FormProvider } from './context/form-context'
import { FormCheckboxSubEntity } from './form-checkbox-sub-entity'
import { FormFieldSubEntity } from './form-field'
import { FormSubmitButtonSubEntity } from './form-submit-button-sub-entity'
import { useOptInSubmitForm } from './hooks/use-opt-in-submit-form'

export interface FormProps {
  entity: FormInterface
}

const BaseForm = ({ entity }: FormProps) => {
  const { calculatedFontSize } = useCalculateTypography({})
  const {
    fontSize: websiteGlobalHeadingFontSize,
    mobileFontSize: websiteGlobalMobileHeadingFontSize,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const { isSuccess, isLoading, checkboxesErrors, commonErrors, onSubmit } =
    useOptInSubmitForm({
      formEntity: entity,
    })

  return (
    <StyleWrapper
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <CommonForm
        entity={entity}
        successOptInScreen={{
          fontSize: calculatedFontSize.desktop,
          mobileFontSize: calculatedFontSize.mobile,
          headerFontSize: websiteGlobalHeadingFontSize,
          headerMobileFontSize: websiteGlobalMobileHeadingFontSize,
          textColor: entity.action.successOptInScreen?.textColor,
          mobileTextColor: entity.action.successOptInScreen?.mobileTextColor,
        }}
        isSuccessOptInScreenOpened={
          isSuccess &&
          entity.action.redirectionType === RedirectionTypesEnum.none
        }
      >
        {entity.subEntities.map(subEntity => {
          if (subEntity.type === FormSubEntityTypeEnum.Field) {
            return (
              <FormFieldSubEntity
                key={subEntity.id}
                formEntity={entity}
                fieldSubEntity={subEntity}
              />
            )
          } else if (subEntity.type === FormSubEntityTypeEnum.Checkbox) {
            return (
              <FormCheckboxSubEntity
                key={subEntity.id}
                formEntity={entity}
                checkboxSubEntity={subEntity}
              />
            )
          } else if (subEntity.type === FormSubEntityTypeEnum.SubmitButton) {
            return (
              <FormSubmitButtonSubEntity
                key={subEntity.id}
                formEntity={entity}
                submitButtonSubEntity={subEntity}
                isLoading={isLoading}
                commonErrors={commonErrors}
                checkboxesErrors={checkboxesErrors}
                onSubmit={onSubmit}
              />
            )
          } else {
            return null
          }
        })}
      </CommonForm>
    </StyleWrapper>
  )
}

export const Form = ({ entity }: FormProps) => {
  return (
    <FormProvider>
      <BaseForm entity={entity} />
    </FormProvider>
  )
}
